export const handleChangeDataInitialData = (name, value) => ({
    type: 'CHANGE_DATA_INITIAL_DATA', name, value
});